// extracted by mini-css-extract-plugin
export default {"userName":"AvatarLabel_userName__cISgS"};